import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { createContract } from '../data-provider';
import type { ContractApi, NewContract } from '../models';
import { CACHE_KEYS } from '../types';

export const useCreateContract = ({ onSuccess }: { onSuccess?: (contract: ContractApi) => void } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: NewContract) => createContract(values),
    onError: () => {
      showNotification({
        message: 'An error has occurred. Please, try again',
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: (contract) => {
      queryClient.invalidateQueries({ queryKey: CACHE_KEYS.all });
      showNotification({
        message: 'Successfully created the contract',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
      onSuccess?.(contract);
    },
  });
};
